import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FeaturesService } from 'src/app/components/plans/features.service';

@Component({
  selector: 'alerts-upgrade-modal',
  templateUrl: './alerts-upgrade-modal.component.html',
  styleUrl: './alerts-upgrade-modal.component.scss',
  standalone: false,
})
export class AlertsUpgradeModalComponent {
  featureAvailable: boolean | null = null;

  constructor(
    public dialogRef: MatDialogRef<AlertsUpgradeModalComponent>,
    private featuresService: FeaturesService,
  ) {
    this.featureAvailable = this.featuresService.isFeatureAvailable(
      FeaturesService.FEATURE_ALERTS,
    );
  }

  openLearnMorePage(): void {
    window.open(
      'https://help.risevision.com/hc/en-us/articles/115005291946-Integrate-Your-CAP-Provider-to-Show-Emergency-and-Audio-Alerts',
      '_blank',
      'noopener,noreferrer',
    );
  }

  get primaryButtonLabel(): string {
    return this.featureAvailable === null ? 'Subscribe Now' : 'Upgrade My Plan';
  }

  upgrade(): void {
    this.dialogRef.close();
    this.featuresService.upgradePlan(FeaturesService.FEATURE_ALERTS);
  }

  close(): void {
    this.dialogRef.close();
  }
}
